import { UpdateFloorSizeDrawer, sizing } from '@dora/components';
import { SxProps } from '@mui/system';
import Preact from 'preact';
import { useDispatch } from 'react-redux';
import { floorSizeUpdatedAction } from '../store/actions/scene';
import * as Selectors from '../store/selectors';
import { useSelector } from './hooks/redux';

export type Model = UpdateFloorSizeDrawer.Model.Model;

export type Props = {
    open: boolean;
    onCancel: () => void;
    onConfirm: (data: Model) => void;
    loading: boolean;
    platform: sizing.Platform;
    portrait: boolean;
    sx?: SxProps;
    paddingTop?: number;
    contentSx?: SxProps;
};

export const Component: Preact.FunctionComponent<Props> = (p: Props) => {
    const [length, width] = useSelector(Selectors.Core.roomDimensions).value();
    const dispatch = useDispatch();

    return (
        <UpdateFloorSizeDrawer.Component
            platform={p.platform}
            portrait={p.portrait}
            open={p.open}
            onClose={p.onCancel}
            loading={p.loading}
            sx={{ ...p.sx }}
            paddingTop={p.paddingTop}
            floorSizeMeters={{ length, width }}
            onUpdate={model => {
                p.onConfirm(model);
                dispatch(
                    floorSizeUpdatedAction({
                        originalDimensions: {
                            x: length,
                            y: width,
                        },
                        newDimensions: {
                            x: model.length,
                            y: model.width,
                        },
                    }),
                );
            }}
        />
    );
};
Component.displayName = 'SpaceDimensionsDrawer';
